import React from "react";
import { Link } from "react-router-dom";

const Terms = () => {
  const getBackUrl = () => {
    if (!localStorage.getItem('is_authenticated')) return '/';
    try {
      const type = JSON.parse(localStorage.getItem('userData') || '{}').userType;
      if (type === 'restaurant') return '/restaurant/dashboard';
      if (type === 'staff') return '/restaurant-staff/employee';
      if (type === 'admin') return '/admin/dashboard';
      if (type === 'vendor') return '/vendor/dashboard';
      if (type === 'customer') return '/customer';
    } catch (e) {}
    return '/';
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-8 md:p-12 space-y-8">
        
        <div className="flex justify-between items-center border-b border-gray-100 pb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Terms and Conditions</h1>
            <p className="text-sm text-gray-500 mt-2">Last Updated: June 2026</p>
          </div>
          <Link to={getBackUrl()} className="text-primary hover:underline font-medium text-sm">
            &larr; Back to App
          </Link>
        </div>

        <div className="space-y-8 text-gray-600 leading-relaxed text-sm md:text-base">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 1. Introduction
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              Welcome to Stellaris! These Terms and Conditions govern your use of our platform. By accessing or using Stellaris, you agree to comply with and be bound by these terms. This is a placeholder document.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 2. User Obligations
            </h2>
            <div className="pl-4 border-l-2 border-gray-100">
              <p className="mb-2">As a user of Stellaris, you agree not to engage in any prohibited activities, including but not limited to:</p>
              <ul className="list-disc pl-5 space-y-2 text-gray-500">
                <li>Violating any applicable laws, regulations, or ordinances.</li>
                <li>Attempting to interfere with the network security of the application.</li>
                <li>Uploading malicious content, scripts, or compromised documents.</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 3. Intellectual Property
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              All content, trademarks, logos, and intellectual property on this site are owned by Stellaris unless otherwise stated. You may not reproduce, distribute, or create derivative works without express permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 4. Limitation of Liability
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              Stellaris shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use the platform. This is a dummy clause for demonstration purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3 flex items-center gap-2">
              <span className="text-primary">•</span> 5. Modifications
            </h2>
            <p className="pl-4 border-l-2 border-gray-100">
              We reserve the right to modify these terms at any time without prior notice. Your continued use of the platform following any changes constitutes full acceptance of the new terms.
            </p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 text-center">
          <button onClick={() => window.history.back()} className="px-6 py-2 bg-primary text-white font-medium rounded shadow hover:bg-opacity-90 transition-all">
            Acknowledge & Return
          </button>
        </div>

      </div>
    </div>
  );
};

export default Terms;
